<p-listbox
	[options]="tableModel.columns"
	[(ngModel)]="selectedColumns"
	[metaKeySelection]="false"
	[checkbox]="true"
	[filter]="true"
	[multiple]="true"
	[listStyle]="{ 'max-height': '250px' }"
	[style]="{ width: '15rem' }"
	(onChange)="selectColumns()"
>
	<ng-template let-column pTemplate="item">
		<div class="country-item">
			<div>{{ column.displayName }}</div>
		</div>
	</ng-template>
</p-listbox>
